module.exports = __webpack_public_path__ + "static/Adverts-61f31976aeb9692cb01fd15d46d3a4cb.svg";